import React from "react";
//#region types
import { EntityIdParams } from "models/propTypes/urlParamsTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { RouteConstants } from "utils/constants";
//#endregion
//#region components
import { useLocation, useParams } from "react-router-dom";
import { ErrorView } from "components/error";
import { LoadingWithLogo, PageLayouts, RouteBreadCrumb } from "components/common";
import CreateQuotation from "./createQuotation";
import QuotationDetailsView from "./detailsView";
import { useQuotesService } from "serviceHooks";
import useQuotationPermissions from "./usePemissions";
//#endregion

const QuotationView: React.FC = () => {
  const quotesService = useQuotesService();
  const [loading, setLoading] = React.useState(true);
  const [quotation, setQuotation] = React.useState<WintSuperkollAPIModel.Quotation>();
  const [key, setKey] = React.useState(0);
  const [isEdit, setIsEdit] = React.useState(false);

  const { canViewQuotations } = useQuotationPermissions();

  const queryParams = new URLSearchParams(useLocation().search);

  const urlParams = useParams<EntityIdParams>();

  const loadQuotation = (serialNumber: number) => {
    quotesService
      .get(serialNumber)
      .then((res) => {
        setQuotation(res);
        setKey(key + 1);
      })
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    const isEditQuotation = Boolean(queryParams.get(RouteConstants.QuotationQueryParams.IsEdit));
    const serialNumber = urlParams.id;
    if (serialNumber) {
      if (quotation?.serialNumber !== Number.parseInt(serialNumber) || isEdit !== isEditQuotation) {
        setLoading(true);
        loadQuotation(Number.parseInt(serialNumber));
        setIsEdit(isEditQuotation);
      }
    } else {
      setQuotation(undefined);
      setLoading(false);
    }
  }, [urlParams]);

  const reloadQuotation = (func?: () => Promise<any>) => {
    if (quotation) {
      setLoading(true);
      if (func) {
        func().then((res) => {
          loadQuotation(quotation.serialNumber);
        });
      } else {
        loadQuotation(quotation.serialNumber);
      }
    }
  };

  return (
    <PageLayouts.EntityFullScreen
      id={quotation?.serialNumber ?? 0}
      entityKey={`quotation`}
      navigation={
        <RouteBreadCrumb
          current={loading ? "" : quotation?.customerName ?? TranslationKeys.Quotation.CreateQuotation}
          showHome
        />
      }
      hasPermissions={canViewQuotations}
      hideSpeedDial={isEdit}
    >
      {loading ? (
        <LoadingWithLogo />
      ) : quotation ? (
        <>
          {isEdit ? (
            <CreateQuotation quotation={quotation} loading={loading}></CreateQuotation>
          ) : (
            <QuotationDetailsView key={key} quotation={quotation} reloadQuotation={reloadQuotation} />
          )}
        </>
      ) : (
        <ErrorView />
      )}
    </PageLayouts.EntityFullScreen>
  );
};

export default QuotationView;
